<template>
  <div>
    <canvas :id="labelName" class="m-auto" width="100" height="30"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  props: [
    "type",
    "labelName",
    "labels",
    "data",
    "colors",
    "borderColor"
  ],
  data() {
    return {
      chartData: {
        type: this.type,
        data: {
          labels: this.labels,
          datasets: [
            {
              label: this.labelName,
              data: this.data,
              backgroundColor: "#1579ab35",
              fill: true,
              fillColor: "#1579ab",
              lineTension: 0,
              borderJoinStyle: "round",
              borderColor: this.borderColor,
              borderWidth: 5,
              pointBorderColor: this.colors
            }
          ]
        },
        options: {
          responsive: true,
          legend: {
            display: false,
            position: "left",
            labels: { boxWidth: 5, defaultFontSize: 18 }
          },
          lineTension: 1,
          scale: {
            pointLabels: {
              fontSize: 16
            },
            ticks: {
              min: 0,
              max: 100
            }
          },
          onClick: function(event, elem) {
            console.log(event);
            var elem = elem[0];
            if (!elem) return; // check and return if not clicked on bar/data
            // else...
            // just for test
            // modal opening code goes here...
          }
        }
      }
    };
  },
  mounted() {
    this.createChart(this.labelName, this.chartData);
  },
  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options
      });
      ctx.onclick = function(evt) {
        // var points = myChart.getDatasetAtEvent(evt);
        // var activeElement = myChart.tooltip;
        // console.log(myChart.getElementsAtEvent(evt))
        var points = evt;
        console.log(points);
      };
    }
  }
};
</script>